import { render, staticRenderFns } from "./couponGoods.vue?vue&type=template&id=205b5c66&scoped=true"
import script from "./couponGoods.vue?vue&type=script&lang=js"
export * from "./couponGoods.vue?vue&type=script&lang=js"
import style0 from "./couponGoods.vue?vue&type=style&index=0&id=205b5c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205b5c66",
  null
  
)

export default component.exports